import { CSSProperties } from "react";

export type TableColumn = {
  id:
    | "serial_number"
    | "sending_address"
    // | "spender_address"
    | "select_all"
    | "wallet_balance";
  labelKey: string;
  minWidth?: CSSProperties["minWidth"];
};

export const TABLE_COLUMNS: readonly TableColumn[] = [
  { id: "serial_number", labelKey: "serial_number" },
  { id: "sending_address", labelKey: "sending_address", minWidth: 270 },
  // { id: "spender_address", labelKey: "spender_address", minWidth: 270 },
  { id: "select_all", labelKey: "select_all" },
  { id: "wallet_balance", labelKey: "wallet_balance", minWidth: 180 },
] as const;

export type TableColumnId = (typeof TABLE_COLUMNS)[number]["id"];
